import { useState } from "react";

import { Accordion, AccordionTab } from "primereact/accordion";

const PREFIXO_STORAGE = 'programacao_relatorio';

export const RELATORIOS_PROGRAMACAO = {
    PCP: 'pcp',
    PROGRAMACAO_TEARES: 'programacao_teares',
    PLANEJAMENTO_ROLADAS: 'planejamento_roladas',
    DECISAO_ABASTECIMENTO: 'decisao_abastecimento',
    RELACAO_TECIDO: 'relacao_tecido',
    HORARIO_PREVISAO: 'horario_previsao',
    GRAFICO_SAIDA_TECIDO: 'grafico_saida_tecido',
    CONSUMO_FIO: 'consumo_fio',
};

function criarStorageKey(relatorio) {
    return `${PREFIXO_STORAGE}_${relatorio}_aberto`;
}

export default function RelatorioAccordion({ children, inicialmenteAberto = true, relatorio, titulo }) {
    const storageKey = criarStorageKey(relatorio);
    const [aberto, setAberto] = useState(() => {
        if (typeof window === 'undefined') {
            return inicialmenteAberto;
        }

        const valorSalvo = window.localStorage.getItem(storageKey);

        return valorSalvo === null ? inicialmenteAberto : valorSalvo === 'true';
    });

    const alternarAccordion = (event) => {
        const proximoEstado = event.index === 0;

        setAberto(proximoEstado);
        window.localStorage.setItem(storageKey, String(proximoEstado));
    };

    return (
        <Accordion
            activeIndex={aberto ? 0 : null}
            className="p-mb-3"
            lazy={false}
            onTabChange={alternarAccordion}
        >
            <AccordionTab header={titulo}>
                {children}
            </AccordionTab>
        </Accordion>
    );
}
